import React, { useEffect, useState } from "react";
import "./CreateOrderNav.css";

const CreateOrderNav = ({ title, stage = 1,stages = 5 }) => {

  const [stagesArray, setStagesArray] = useState([0,1,2,3,4]);

  useEffect(() => {

    setStagesArray(Array.from(Array(stages).keys()));
    
  }, [stages])

  return (
    <nav className="createOrderNavbarMenu">
      <h2 className="createOrderNavbarMenuTitle">{title}</h2>
      <div className="createOrderNavbarMenuStages">
        {stagesArray.map( s => 
        <div key={s}
          className={
            s < stage
              ? "createOrderNavbsrMenuStage"
              : "createOrderNavbsrMenuStage notChoosenStage"
          }
        ></div>
        )}
      </div>
    </nav>
  );
};

export default CreateOrderNav;
